export default __webpack_public_path__ + "static/media/design-11.abfa6a89.png";